import { type FC } from 'react';
import cn from 'classnames';

import {
  type PaidSpecContractType,
  type SpecContractType,
} from '@/common/types/contract';
import { MotionPicture } from '@/components/ui/Picture/Picture';
import { selectSpecContractIsFail } from '@/redux/selectors/contractSelectors';
import { useAppSelector } from '@/redux/store';

import goldenFailPng from '/img/icons/golden_contract/Fail.png';
import goldenFailWebp from '/img/icons/golden_contract/Fail.webp';

interface FailOverlayProps {
  kind: SpecContractType | PaidSpecContractType;
}

const FailOverlay: FC<FailOverlayProps> = ({ kind }) => {
  const contractIsFail = useAppSelector((state) =>
    selectSpecContractIsFail(state, kind),
  );

  return (
    contractIsFail && (
      <MotionPicture
        initial={{ opacity: 0, scale: 1.5, x: '-50%' }}
        animate={{ opacity: 1, scale: 1, x: '-50%' }}
        transition={{ duration: 0.5 }}
        className={cn(
          'absolute left-1/2 w-[85%] aspect-[322/198] z-[2]',
          kind === 'Blitz' || kind === 'BlitzPlus' ? 'top-[3.25rem]' : 'top-8',
        )}
        img={goldenFailPng}
        webp={goldenFailWebp}
        alt="fail"
      />
    )
  );
};

export { FailOverlay };
